export const CORE_LOCALIZATIONS = ['de', 'en', 'es', 'fr', 'it', 'ja', 'pt'];

// EXTENDED_LOCALIZATIONS are used for app download page - https://welltech.atlassian.net/browse/UPP-212
export const EXTENDED_LOCALIZATIONS = [
    'bg',
    'cs',
    'da',
    'el',
    'et',
    'fi',
    'hr',
    'hu',
    'ja',
    'kk',
    'ko',
    'lt',
    'lv',
    'no',
    'pl',
    'ro',
    'sk',
    'sl',
    'sv',
    'tr',
];

export const AVAILABLE_LOCALIZATIONS = [...CORE_LOCALIZATIONS, ...EXTENDED_LOCALIZATIONS];
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_NAVIGATOR_LANGUAGE = 'en-US';

export const FAQ_AVAILABLE_LANGUAGES: Record<string, string> = {
    en: 'en-us',
    fr: 'fr-fr',
    de: 'de-de',
    it: 'it-it',
    es: 'es-es',
    pt: 'pt-br',
};
